import { combineReducers } from 'redux';
import { locationDuck } from '@eb/redux-destination';

const {
    reducersByKey: {
        suggestions,
        slug,
        placeId,
        latitude,
        longitude,
        currentPlace,
        currentPlaceParent,
        placeType,
        isWaitingForLocation,
        isUsingCurrentLocation,
        isOnline,
        locationDenied,
    },
} = locationDuck;

export default combineReducers({
    suggestions,
    slug,
    latitude,
    longitude,
    placeId,
    placeType,
    isWaitingForLocation,
    isUsingCurrentLocation,
    isOnline,
    locationDenied,
    currentPlace,
    currentPlaceParent,
    topSuggestions: (state = []) => state,
    trendingSearchCities: (state = []) => state,
    cityBlurb: (state = '') => state,
    currentLocationCoordinates: (state = {}) => state,
    h1Prefix: (state = '') => state,
});
